import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { TrustBadges } from './TrustBadges';
import { checkoutUrl, productImage } from './constants';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(previous => {
      if (previous.seconds > 0) return {
        ...previous,
        seconds: previous.seconds - 1
      };
      if (previous.minutes > 0) return {
        ...previous,
        minutes: previous.minutes - 1,
        seconds: 59
      };
      if (previous.hours > 0) return {
        hours: previous.hours - 1,
        minutes: 59,
        seconds: 59
      };
      return {
        hours: 1,
        minutes: 30,
        seconds: 5
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <section id="offre" className="py-4 px-4 sm:px-6 bg-white border-y-4 border-brand-gold/60 scroll-mt-2" data-id="element-86" data-mp="2xk9i4vqvbhzw">
      <div className="text-center mb-2" data-id="element-87" data-mp="2sr6lufuphug0">
        <p className="text-[11px] font-heading font-bold text-brand-magenta uppercase tracking-widest" data-id="element-88" data-mp="32klzwm59qjhk">
          Offre spéciale — Système complet 6-en-1
        </p>
        <p className="text-[13px] font-semibold text-brand-slate mt-0.5 leading-snug" data-id="element-89" data-mp="37inlpeu2wwwq">
          Accédez dès aujourd&apos;hui au système qui transformera votre façon de préparer vos entraînements.
        </p>
        <p className="font-heading font-bold text-brand-violet text-sm sm:text-base mt-2 leading-tight" data-id="element-90" data-mp="2xrj74g8bfe2f">
          GYM RYTHMIQUE PRO™ — Le Système Complet de Planification 6-en-1 pour les Professeurs de Gymnastique Rythmique
        </p>
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block mt-2" data-id="element-91" data-mp="29w6kvzm50168">
          <img src={productImage} alt="Gym Rythmique Pro — Système Complet 6-en-1" className="w-full max-w-[220px] mx-auto drop-shadow-lg" data-id="element-92" data-mp="2eu872tev0glx" />
        </a>
      </div>
      <div className="bg-white border-4 border-brand-gold rounded-lg p-3.5 text-center shadow-xl" data-id="element-93" data-mp="d3n0hmxvikju">
        <p className="text-xs font-bold text-brand-violet leading-tight" data-id="element-94" data-mp="bmhka4mduhzl">
          ✅ 6 Modules Professionnels &nbsp;•&nbsp; ✅ 5 Bonus Premium
        </p>
        <p className="text-[13px] font-semibold text-brand-slate mt-1" data-id="element-95" data-mp="6phelutg3h90">
          Prix habituel : <span className="line-through" data-id="element-96" data-mp="1q4ggdx4inr4">97 €</span>
        </p>
        <p className="text-[13px] font-heading font-bold text-brand-magentaDark uppercase leading-tight mt-0.5" data-id="element-97" data-mp="3tsvwnz506jvv">
          🔥 Offre de lancement — 72 % de réduction
        </p>
        <p className="text-xs font-heading font-bold text-brand-violet mt-1.5 uppercase" data-id="element-98" data-mp="pd49952cctih">
          Aujourd&apos;hui seulement :{' '}
          <span className="text-4xl sm:text-5xl font-display tracking-wide align-middle" data-id="element-99" data-mp="kll2l6dq6td1">27 €</span>
        </p>
        <p className="text-[10px] font-bold text-brand-slate/70 uppercase tracking-wider" data-id="element-100" data-mp="gl29za40dj9s">
          Payez en toute sécurité dans votre devise locale.
        </p>
        <div className="bg-brand-cream border border-brand-pink rounded p-2 my-3" data-id="element-101" data-mp="18c8d7zf0zx3a">
          <p className="text-[11px] font-bold text-brand-magentaDark uppercase leading-tight" data-id="element-102" data-mp="2qzrsf1bh9xaa">
            🔥 Cette offre disparaîtra lorsque le compteur atteindra zéro.
          </p>
          <div className="flex items-start justify-center gap-1.5 mt-1.5" data-id="element-103" data-mp="2zzwq2jqvdhb9">
            <TimeBox value={timeLeft.hours} label="HEURES" data-id="element-104" data-mp="30211dmr3lilk" />
            <span className="text-brand-violet font-bold text-lg leading-none" data-id="element-105" data-mp="3502iw38vl9ux">:</span>
            <TimeBox value={timeLeft.minutes} label="MINUTES" data-id="element-106" data-mp="39yw0a6ra9l0d" />
            <span className="text-brand-violet font-bold text-lg leading-none" data-id="element-107" data-mp="39w9pzzd0creg">:</span>
            <TimeBox value={timeLeft.seconds} label="SECONDES" data-id="element-108" data-mp="3ev2tcyykz20w" />
          </div>
        </div>
        <CTAButton href={checkoutUrl} data-id="element-109" data-mp="3jop76ughdbya">🚀 OUI ! JE VEUX MON SYSTÈME COMPLET 6-EN-1</CTAButton>
      </div>
      <TrustBadges className="mt-2" data-id="element-110" data-mp="3nrlkq6r5yhvd" />
    </section>;
}
function TimeBox({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="text-center" data-id="element-111" data-mp="1hrgdt7f53sq">
      <div className="bg-brand-violet text-white text-lg font-heading font-bold px-2 py-1 rounded leading-none" data-id="element-112" data-mp="1isqnvgm1m9e">
        {String(value).padStart(2, '0')}
      </div>
      <p className="text-[8px] font-bold text-brand-slate mt-0.5" data-id="element-113" data-mp="3f2eksdy12vee">{label}</p>
    </div>;
}